/* ============================================================
   OSO PICKLEBALL — Global JS
   Scroll reveal system, cart AJAX, mobile nav
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Scroll reveal (IntersectionObserver) ---------- */
  const revealEls = document.querySelectorAll('.rv, .rv-left');
  if (revealEls.length) {
    if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
      );
      revealEls.forEach((el) => observer.observe(el));
      // Fallback: reveal all after 800ms in case observer doesn't fire (e.g. preview mode)
      setTimeout(function() {
        revealEls.forEach((el) => el.classList.add('in'));
      }, 800);
    } else {
      // Reduced motion: show everything immediately
      revealEls.forEach((el) => el.classList.add('in'));
    }
  }

  /* ---------- Mobile nav drawer ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    const burger = document.querySelector('.oso-burger');
    const drawer = document.querySelector('.oso-nav-drawer');
    const drawerClose = document.querySelector('.oso-nav-drawer__close');

    if (burger && drawer) {
      burger.addEventListener('click', function () {
        const isOpen = drawer.getAttribute('aria-hidden') === 'false';
        drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        burger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        document.body.style.overflow = isOpen ? '' : 'hidden';
      });
    }

    if (drawerClose && drawer) {
      drawerClose.addEventListener('click', function () {
        drawer.setAttribute('aria-hidden', 'true');
        if (burger) burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    }

    // Close drawer on outside click
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) {
          drawer.setAttribute('aria-hidden', 'true');
          if (burger) burger.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        }
      });
    }

    /* ---------- Quick-buy AJAX ---------- */
    const quickBuyForms = document.querySelectorAll('.oso-quick-buy');
    quickBuyForms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const variantId = form.dataset.variantId;
        if (!variantId) return;

        const btn = form.querySelector('.oso-quick-buy__btn');
        const originalText = btn ? btn.textContent : '';
        if (btn) {
          btn.textContent = 'Adding...';
          btn.disabled = true;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then((res) => res.json())
          .then(function () {
            if (btn) {
              btn.textContent = 'Added!';
              setTimeout(function () {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 1800);
            }
            // Update cart count
            return fetch('/cart.js');
          })
          .then((res) => res.json())
          .then(function (cart) {
            const countEls = document.querySelectorAll('.oso-cart-count');
            countEls.forEach(function (el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? 'inline' : 'none';
            });
          })
          .catch(function () {
            if (btn) {
              btn.textContent = originalText;
              btn.disabled = false;
            }
          });
      });
    });

    /* ---------- Email form inline feedback ---------- */
    const emailForms = document.querySelectorAll('.oso-email-form');
    emailForms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const emailInput = form.querySelector('input[type="email"]');
        const msgEl = form.querySelector('.oso-email-form__msg');
        const successText = form.dataset.successMsg || 'You\'re on the list.';
        const errorText = form.dataset.errorMsg || 'Something went wrong. Try again.';

        if (!emailInput || !emailInput.value || !emailInput.checkValidity()) {
          if (emailInput) emailInput.reportValidity();
          return;
        }

        const setMessage = function (text, status) {
          if (!msgEl) return;
          msgEl.textContent = text;
          msgEl.style.display = 'block';
          msgEl.className = 'oso-email-form__msg oso-email-form__msg--' + status;
        };

        /* Shopify generates the required customer-form endpoint and hidden inputs.
           Submit that complete form; posting a hand-built payload to `/` bypasses it. */
        const action = form.action.split('#')[0] || window.location.pathname;
        const formData = new FormData(form);

        fetch(action, {
          method: (form.method || 'post').toUpperCase(),
          body: formData,
          credentials: 'same-origin',
          headers: { 'Accept': 'text/html,application/xhtml+xml' },
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Customer form submission failed.');
            setMessage(successText, 'success');
            emailInput.value = '';
          })
          .catch(function () {
            setMessage(errorText, 'error');
          });
      });
    });

    /* ---------- Sleeping bear easter egg ---------- */
    const bear = document.querySelector('.oso-sleep-bear');
    if (bear) {
      bear.addEventListener('mouseenter', function () {
        bear.textContent = '🐻';
      });
      bear.addEventListener('mouseleave', function () {
        bear.textContent = '😴';
      });
      bear.addEventListener('touchstart', function () {
        bear.textContent = bear.textContent === '😴' ? '🐻' : '😴';
      }, { passive: true });
    }
  });
})();
